import { createContext } from 'react'

type Props = {
  ids: string[]
  addId: (newId: string) => void
  removeId: (idToRemove: string) => void
  removeAllIds: () => void
  isEdit: (idToCheck: string) => boolean
}

export const PanelContext = createContext<Props | undefined>(undefined)
